import { render, staticRenderFns } from "./company-order.vue?vue&type=template&id=51c94b76"
import script from "./company-order.vue?vue&type=script&lang=js"
export * from "./company-order.vue?vue&type=script&lang=js"
import style0 from "./company-order.vue?vue&type=style&index=0&id=51c94b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports